<template>
    <AddParent />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AddParent from "@/components/Parent/AddParent.vue";
  
    export default defineComponent({
      name: "AddParentPage",
      components: {
        
        AddParent,
      },
    });
  </script>